<template>
  <div class="relative flex flex-col items-center">
    <HomeSection full>
      <SectionHeroEnrich />

      <ProductTrophies class="mt-32" />

      <SectionStats class="mt-32" />
    </HomeSection>

    <HomeSection image="map">
      <div class="flex flex-col gap-12">
        <SectionApiFeatures />
      </div>
    </HomeSection>

    <HomeSection>
      <div class="py-12">
        <SectionSdk />
      </div>
    </HomeSection>

    <HomeSection
      image="watch"
      image-height="h-[800px]"
    >
      <SectionFeaturesBlocks />
    </HomeSection>

    <HomeSection
      id="pricing"
      image="search"
      image-height="h-[920px]"
    >
      <SectionPricing
        is-main-section
        :trophies="false"
      />
    </HomeSection>

    <HomeSection
      image="mountain"
      reverse
    >
      <div class="flex flex-col gap-12">
        <SectionSupport />
      </div>
    </HomeSection>
  </div>
</template>
